// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'cfa457bd-a36a-46bf-9d73-33e2985f5f59',
      type: 'Sprite',
      name: 'icon',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.356021,
        y: 0.351064
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Collect_Event_Icon_Flame',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '79f41553-d680-49e3-b7c1-8f098ec59c1b',
      type: 'Text',
      name: 'amountText',
      className: '',
      x: 21.36126,
      y: 24.57448,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.356021,
        y: 0.351064
      },
      angle: 0,
      alpha: 0,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '+1',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 80,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#490C03',
        strokeThickness: 7,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  animations: [
    {
      id: '3684f346-42f7-4d45-a965-53d2c31f714c',
      name: 'In_Game_Collect',
      playingSpeed: 1,
      totalDuration: 1000,
      blocks: [
        {
          id: 'a6c28327-2cf2-461a-85e8-52476800b033',
          type: 'Setter',
          name: 'icon',
          track: 1,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'icon',
          disabled: false
        },
        {
          id: 'ef4de07f-7f60-46f2-94b1-f81616e4ff68',
          type: 'Setter',
          name: 'textAlpha',
          track: 8,
          target: {
            alpha: 1,
            scale: {
              x: 0,
              y: 0
            },
            x: 20,
            y: 30
          },
          startAt: 0,
          sourceName: 'amountText',
          disabled: false
        },
        {
          id: '9394538a-04d7-429a-ba00-244cd6483b8b',
          type: 'Tween',
          name: 'iconScale_copy_1',
          duration: 290,
          track: 8,
          target: {
            scale: {
              x: 0.5,
              y: 0.52
            }
          },
          startAt: 10,
          sourceName: 'amountText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '601615d2-bc30-4d87-bbd7-cc5f4a2ced5f',
          type: 'Tween',
          name: 'iconPosition_copy',
          duration: 290,
          track: 3,
          target: {
            y: 0
          },
          startAt: 10,
          sourceName: 'icon',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '17238399-7d91-46bf-b48e-0fa52a40d84a',
          type: 'Tween',
          name: 'iconScale',
          duration: 290,
          track: 2,
          target: {
            scale: {
              x: 0.65,
              y: 0.65
            }
          },
          startAt: 10,
          sourceName: 'icon',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'de8f7702-1177-4a63-90de-2f0b2eb649a3',
          type: 'Tween',
          name: 'iconPosition',
          duration: 800,
          track: 5,
          target: {
            y: -80
          },
          startAt: 200,
          sourceName: 'icon',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'c7314d83-11b1-4c04-b3ce-87eacd03f54b',
          type: 'Tween',
          name: 'iconPosition_1',
          duration: 800,
          track: 9,
          target: {
            y: -50
          },
          startAt: 201,
          sourceName: 'amountText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'e98a3165-c4a4-4a26-8e8f-e96a04a3cc2f',
          type: 'Tween',
          name: 'iconScale_copy',
          duration: 100,
          track: 2,
          target: {
            scale: {
              x: 0.46,
              y: 0.46
            }
          },
          startAt: 300,
          sourceName: 'icon',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '465e64d8-151d-4b11-8305-e37f3e98f206',
          type: 'Tween',
          name: 'textScale',
          duration: 100,
          track: 8,
          target: {
            scale: {
              x: 0.46,
              y: 0.46
            }
          },
          startAt: 300,
          sourceName: 'amountText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'a452afc1-ce3e-4334-a9c6-cda246b27f2c',
          type: 'Tween',
          name: 'textAlpha_copy',
          duration: 500,
          track: 10,
          target: {
            alpha: 0
          },
          startAt: 498,
          sourceName: 'amountText',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class CollectEventFiredUpForgeTokenLayout {
  static raw = raw;
  root!: Container;
  icon!: Sprite;
  amountText!: Text;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class In_Game_Collect {
  Layout: {
    icon: object;
    amountText: object;
  };

  BlockTypeByName: {
    icon: object;
    textAlpha: object;
    iconScale_copy_1: object;
    iconPosition_copy: object;
    iconScale: object;
    iconPosition: object;
    iconPosition_1: object;
    iconScale_copy: object;
    textScale: object;
    textAlpha_copy: object;
  };

  flowData = raw.animations[0];
}
